import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { IFrontendSetting } from "@faire/web/common/settings/declarations/IFrontendSetting";
import { NullableSettingType } from "@faire/web/common/settings/declarations/ISettingSchema";

/**
 * Frontend settings expose their default value in the object,
 * so there is no need to explicitly pass a default value and
 * no need to create a separate wrapper hook for each setting.
 */
export function useFrontendSetting<T extends NullableSettingType>(
  setting: IFrontendSetting<T>
): T {
  return useSetting(setting);
}
